import React, { Component } from "react";
import { View, StyleSheet, ScrollView, Alert, TouchableOpacity, TouchableWithoutFeedback } from "react-native";
//  import { Snackbar, Button } from 'react-native-paper'
// import Icon from "react-native-vector-icons/dist/Ionicons";
// import { isIos, width, isIphoneX } from "../Utils";
// // import { data } from "../../api/questions";
import QuestionComponent from './questionComponent';
import Toaster from './../../components/snackBar_toaster';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { selectedAnswers, changeQuestion, submitTest, dispatchClearHomeInfo, clearTest, getAllTestsInfo } from './../../store/actions';
// import { } from 'reac-navigation';
// import { resetAll } from './../../navigators/navigationService';
// import Icons from 'react-native-vector-icons/MaterialIcons';
// import { deviceWidth, firebaseLogEvent } from './../Utils';
// import Toast, { DURATION } from 'react-native-easy-toast';
// import Colors from '../Colors';
// import LinearGradientComponent from './../HeaderBackgroundComponent';
// import GestureRecognizer, {swipeDirections} from './../UI-Components/gestureRecogniseComponent';
import { Text, Styles } from "./../../components/UI-Components"
import { CHALLENGE_TEST } from "../../store/constants";
import Icon from '@material-ui/core/Icon';
import ReorderIcon from '@material-ui/icons/Reorder';
import SelectedScreen from './selectedAnswerScreen';
import SubmitDialog from './submitDialogBox';
import { ActivityIndicator } from "react-native-paper";
// import QuestionComponent from './newQuizScreen/questionComponent';
import './newQuizScreen/quiz.scss';
import { Button } from './../../components';


class TestAttempt extends Component {

  constructor(props) {
    super(props);
    this.state = {
      qNo: 0,
      snackbarMsg: null,
      visible: false,
      showToast: false,
      toasterMessage: '',
      showSelectedScreen: false,
      submitDialogOpen: false
    };
  }

  componentWillUnmount() {
    this.props.clearTest();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.submitTestResponse !== this.props.submitTestResponse) {

      if (this.props.submitTestResponse) {

        this.showToaster('Test Successfully Submitted')
        const testId = this.props.requestedTestId;

        // const attemptingTestId = this.props.attemptingTestId;
        // const testId = null;
        const { state = {} } = this.props.location;
        const { isTestSeries } = state;
        // // console.log(testId, attemptingTestId, 'quiz attemting testid', isPlannedTest);
        // const _testId = testId && testId.test_id;

        // this.props.navigation.navigate('LeaderBoardForChallengeTests', {
        //   testId:  _testId,
        //   // navigateToHome: true,
        //   // isPlannedTest,
        //   addExtraTime: true,
        //   isAdminTest: isAdminTest
        //   // isTestSeries
        // })

        // if(isPlannedTest) firebaseLogEvent('planned_test_submitted', {});
        // if(isTestSeries) firebaseLogEvent('test_series_test_submitted', {});


        // if((this.props.testType === CHALLENGE_TEST)) {         
        //   if(isAdminTest) {
        //     // firebaseLogEvent('admin_test_submitted', {});
        //   }else {
        //     // firebaseLogEvent('challenge_test_submitted', {});
        //   }
        //   setTimeout(() => {
        //     this.props.clearTest();
        //     this.props.getAllTestsInfo();
        //     const _testId = testId.test_id
        //     this.props.navigation.push('LeaderBoardForChallengeTests', {
        //       testId:  _testId,
        //       isAdminTest: isAdminTest,
        //       addExtraTime: true,                
        //     })
        //   }, 800);
        //   return;
        // }

        if (testId) {
          setTimeout(() => {
            this.props.clearTest();
            this.props.getAllTestsInfo();
            this.props.history.push('/ShowResults', {
              testId: testId,
              navigateToHome: true,
              isPlannedTest: false,
              addExtraTime: true,
              isTestSeries
            })
          }, 800);
        } else {
          this.props.dispatchClearHomeInfo();
          setTimeout(() => {
            // resetAll(this.props.navigation, 'Home');
            this.props.history.push('/Home')
          }, 800);
        }
      }
    }

    if (prevProps.submitTestError !== this.props.submitTestError) {
      if (this.props.submitTestError) {
        const errorMessage = this.props.submitTestErrInfo || 'some thing went wrong';
        this.showToaster(errorMessage)
      }
    }
    if (prevProps.submitTestLoading !== this.props.submitTestLoading) {
      if (this.props.submitTestLoading) {
        this.setState({
          submitDialogOpen: false
        })
      }
    }
  }



 
  showToaster = (msg) => {
    this.setState({
      showToast: true,
      toasterMessage: msg
    })
  }

  openModal = () => {
    this.setState({
      submitDialogOpen: true
    })
  }

  render() {
    const config = {
      velocityThreshold: 0.3,
      directionalOffsetThreshold: 80
    };
    // const isPlannedTest = this.props.navigation.getParam('plannedTest', false);    
    // const isTestSeries = this.props.navigation.getParam('isTestSeries', false);   
    // const { state={}} = this.props.location;
    // const { isTestSeries  } = this.state;


    const { qNo, snackbarMsg, visible } = this.state;
    const { data, selectedAnswers, answers, changeQuestion, activeQuestion, totalQuestions, submitTestResponse, submitTestLoading, passages } = this.props;

    return (
      <>
        <div className='my-2 d-flex flex-column' >
              <div style={{
                  display: 'flex',
                  flexWrap: 'wrap',                  
              }}>
            <QuestionComponent
              data={data && data[activeQuestion]}
              checkedAnswers={selectedAnswers}
              answers={answers}
              qNo={activeQuestion}
              passages={passages}
              navigation={this.props.navigation}
            /> 
           </div>            
          <Toaster
            show={this.state.showToast}
            message={this.state.toasterMessage}
          />
        </div>
        {
          this.state.showSelectedScreen ?
            <SelectedScreen
              open={this.state.showSelectedScreen}
              handleClose={() => this.setState({ showSelectedScreen: false })}
            />
            : null
        }
        {
          this.state.submitDialogOpen ?
            <SubmitDialog
              open={this.state.submitDialogOpen}
              handleClose={
                () => this.setState({
                  submitDialogOpen: false
                })
              }
              handleSubmitTest={() => this.props.submitTest(false, true)}
            />
            : null
        }
      </>
    );
  }
}

// const bttomVal = isIphoneX() ? 70 : 0;

const styles = StyleSheet.create({
  buttons: {
    // paddingHorizontal: 8,
    // paddingVertical: 16,
    // margin: 4,
    // borderWidth: 1,
    // borderRadius:4,
    // backgroundColor:'red'
  },
  bottom: {
    // borderWidth:1,
    // width: deviceWidth-30,
    // paddingVertical: 20,
    justifyContent: "space-between",
    flexDirection: "row",
  }
});

const mapStateToProps = state => {
  return {
    testInfo: state.testInfo && state.testInfo,
    testAllQuestions: state.testInfo && state.testInfo.test && state.testInfo.test,
    answers: state.testInfo.selectedAnswers || [],
    activeQuestion: state.testInfo && state.testInfo.activeQuestion,
    totalQuestions: state.testInfo && state.testInfo?.test?.length,
    passages: state.testInfo && state.testInfo.passages,
    requestedTestId: state.testInfo && state.testInfo.requestedTestId && state.testInfo.requestedTestId,
    attemptingTestId: state.testInfo && state.testInfo.testId,
    submitTestLoading: state.submitTest && state.submitTest.loading && state.submitTest.loading,
    submitTestError: state.submitTest && state.submitTest.error && state.submitTest.error,
    submitTestErrInfo: state.submitTest && state.submitTest.errInfo && state.submitTest.errInfo.data && state.submitTest.errInfo.data.message,
    submitTestResponse: state.submitTest && state.submitTest.response && state.submitTest.response,
    testType: state.testInfo && state.testInfo.totalResponse && state.testInfo.totalResponse.test_type
  }
}


export default connect(mapStateToProps, { selectedAnswers, changeQuestion, submitTest, dispatchClearHomeInfo, clearTest, getAllTestsInfo })(withRouter(TestAttempt));
